import React from 'react'

const SubMenuItem = ({item}) => {
    const currentPath = window.location.pathname; // Get the current URL path
    const isActive = currentPath === item.link; 
    return (
        <li className={`menu-item menu-item-type-post_type menu-item-object-page menu-item-2566 ${isActive ? 'current_page_item current-menu-item' : ''}`}>
            <a href={item.link}>
                <span className="qodef-menu-item-text">{item.text}</span>
            </a>
        </li>
    )
}

export default SubMenuItem
